// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"72c64818","27":"f48fc5b5","174":"68011a14","216":"0e5eec8c","272":"173b70ca","281":"8650e763","310":"525ea139","432":"ebb49c05","627":"c0a44d29","675":"82fe05ad","778":"c57013af","788":"f995fb65"}[chunkId] + ".chunk.js";
};